module.exports = __webpack_public_path__ + "static/media/AccoladesIMG@2x.2d650e9a.png";